<template>
  <!-- OFFER SECTION START -->
  <section id="offer" class="offer-section">
    <div class="offer-container">
      <div class="offer-header">
        <h2>Let’s Work Together</h2>
        <p class="offer-subtitle">Freelance • Collaboration • Small Help</p>
      </div>

      <!-- Language Toggle -->
      <!-- <div class="offer-lang-toggle">
        <button
          class="offer-lang-btn"
          :class="{ active: currentLang === 'id' }"
          @click="setLang('id')"
        >
          Bahasa Indonesia
        </button>

        <button
          class="offer-lang-btn"
          :class="{ active: currentLang === 'en' }"
          @click="setLang('en')"
        >
          English
        </button>
      </div> -->

      <!-- Bahasa Indonesia Version -->
      <div class="offer-card" v-show="currentLang === 'id'">
        <h3>Terbuka untuk Tawaran Freelance & Kolaborasi</h3>
        <p>
          Saat ini saya <strong>terbuka untuk proyek freelance</strong>, kerja sama kecil,
          atau bahkan sekadar bantuan jika kamu sedang buntu. Untuk urusan budget,
          saya cukup fleksibel — saya tidak membatasi, dan kalau kamu hanya butuh bantuan ringan,
          saya dengan senang hati bisa membantu secara sukarela.
        </p>

        <p>
          Yang saya harapkan cuma satu: <strong>jangan terlalu memaksa</strong>.
          Saya selalu berusaha memberikan yang terbaik karena bagi saya,
          setiap pekerjaan adalah <strong>tanggung jawab yang harus diselesaikan dengan baik</strong>.
        </p>

        <div class="offer-boxes">
          <div class="offer-box">
            <h4>Budget minim</h4>
            <p>
              Untuk budget yang minim, <strong>saya tidak keberatan</strong>.
              Tapi mohon dipahami kalau hasil yang saya buat akan lebih ke arah yang
              <strong>simple, fungsional, dan seperlunya saja</strong>.
            </p>
          </div>

          <div class="offer-box">
            <h4>Desain unik & custom</h4>
            <p>
              Jika kamu ingin <strong>halaman yang benar-benar unik</strong>
              (konsep khusus, detail desain, dan sentuhan extra),
              saya membuka harga mulai dari <strong>1 Juta</strong> ke atas.
            </p>
          </div>

          <div class="offer-box">
            <h4>Preview & revisi</h4>
            <p>
              Saya akan memberikan <strong>preview</strong> terlebih dahulu.
              Kalau kamu kurang suka, silakan beri komentar dan masukan.
              Namun jika tuntutan terasa <strong>terlalu aneh, tidak masuk akal, atau di luar kemampuan saya</strong>,
              saya berhak untuk <strong>membatalkan proyek</strong>.
            </p>
          </div>
        </div>

        <p class="offer-note">
          Kalau kamu tertarik atau hanya ingin tanya-tanya lebih dulu,
          jangan ragu untuk menghubungi saya lewat <a href="https://www.instagram.com/kasekiru" style="text-decoration: underline;">Instagram</a>, atau platform social media lainnya. 😊   
          <br><br>
          <em>Sebagai tambahan…</em><br>
          Jika kamu adalah <strong>pelajar yang sedang kesulitan</strong>,
          saya akan dengan senang hati membantu. dan malah saya akan senang kalau bisa berhasil membantumu.
          Serius — saya tidak mata duitan kok 😭.  
          Sampai sekarang, saya sudah membantu <strong>puluhan teman</strong> secara sukarela.
          Jadi jangan sungkan yaa ✨.
        </p>
      </div>

      <!-- English Version -->
      <div class="offer-card" v-show="currentLang === 'en'">
        <h3>Open for Freelance & Collaboration</h3>
        <p>
          I’m currently <strong>open for freelance projects</strong>, small collaborations,
          or even simple help if you’re stuck on something.
          When it comes to budget, I’m quite flexible — I don’t strictly limit it,
          and if you only need a bit of help, I’m happy to assist <strong>voluntarily</strong>.
        </p>

        <p>
          The only thing I hope for is: <strong>please don’t push too hard</strong>.
          I always try to do my best, because for me, every project is a
          <strong>responsibility that should be finished properly</strong>.
        </p>

        <div class="offer-boxes">
          <div class="offer-box">
            <h4>Low budget</h4>
            <p>
              For a lower budget, <strong>that’s still okay</strong>.
              Just understand that the result will be more
              <strong>simple, straightforward, and focused on what’s necessary</strong>.
            </p>
          </div>

          <div class="offer-box">
            <h4>Truly unique & custom design</h4>
            <p>
              If you want a <strong>truly unique page</strong>
              (custom concept, detailed design, and extra polish),
              my pricing starts from <strong>US$100</strong> and above.
            </p>
          </div>

          <div class="offer-box">
            <h4>Preview & feedback</h4>
            <p>
              I’ll provide a <strong>preview</strong> first.
              If you don’t like it, you’re welcome to give comments and feedback.
              However, if the requirements become <strong>too strange, unrealistic, or beyond what I can reasonably do</strong>,
              I may choose to <strong>cancel the project</strong>.
            </p>
          </div>
        </div>

        <p class="offer-note">
          If you're interested or simply want to ask a few questions first,
          feel free to reach out to me through <a href="https://www.instagram.com/kasekiru" style="text-decoration: underline;">Instagram</a> or any other social platform. 😊  
          <br><br>
          <em>And just a little note…</em><br>
          If you are a <strong>student who is struggling</strong>,
          I’m more than happy to help — honestly, I’ll be glad if I can make things easier for you.
          Seriously — I’m not money–oriented at all 😭.  
          Up to now, I’ve already helped <strong>dozens of my friends</strong> completely for free.
          So please don’t hesitate, okay? ✨
        </p>
      </div>
    </div>
  </section>
  <!-- OFFER SECTION END -->
</template>

<script>
export default {
  name: "Collaborate",
  props: {
    lang: {
      type: String,
      default: "id",
    },
  },
  data() {
    return {
      currentLang: this.lang,
    };
  },
  watch: {
    lang(newVal) {
      this.currentLang = newVal;
    },
  },
  methods: {
    setLang(l) {
      this.currentLang = l;
      this.$emit("update:lang", l); // biar parent ikut berubah kalau mau
    }
  }
};
</script>

<style scoped>
/* style persis seperti aslinya */
.offer-section {
  padding: 3rem 1.5rem;
  display: flex;
  justify-content: center;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.offer-container {
  width: 100%;
  text-align: justify;
  max-width: 900px;
}

.offer-header {
  text-align: center;
  margin-bottom: 2rem;
}

.offer-header h2 {
  font-size: 2rem;
  margin-bottom: 0.25rem;
}

.offer-subtitle {
  font-size: 0.95rem;
  opacity: 0.7;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.offer-lang-toggle {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.offer-lang-btn {
  border: 1px solid rgba(0,0,0,0.15);
  background: #f5f5f5;
  padding: 0.4rem 0.9rem;
  border-radius: 999px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.1s ease, box-shadow 0.2s ease;
}

.offer-lang-btn.active {
  background: #111;
  color: #fff;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.offer-lang-btn:hover {
  transform: translateY(-1px);
}

.offer-card {
  border-radius: 1rem;
  padding: 1.75rem 1.5rem 2rem;
  background: #ffffff55;
  box-shadow: 0 14px 40px rgba(0,0,0,0.06);
  line-height: 1.6;
  font-size: 0.95rem;
}

.offer-card h3 {
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 1.35rem;
}

.offer-boxes {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 1rem;
  margin: 1.5rem 0;
}

.offer-box {
  border-radius: 0.85rem;
  padding: 1rem;
  text-align: justify;
  background: #f7f7f777;
  font-size: 0.9rem;
}

.offer-box h4 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  text-align: center;
  font-size: 0.95rem;
  font-weight: 700;
}

.offer-note {
  margin-top: 1rem;
  font-size: 0.9rem;
  text-align: justify;
  opacity: 0.9;
}

.hidden {
  display: none;
}

@media (prefers-color-scheme: dark) {
  .offer-section {
    background: #050505;
  }
  .offer-card {
    background: #111;
    color: #f5f5f5;
    box-shadow: 0 14px 40px rgba(0,0,0,0.6);
  }
  .offer-box {
    background: #1a1a1a;
  }
  .offer-lang-btn {
    background: #1b1b1b;
    color: #f5f5f5;
    border-color: #333;
  }
  .offer-lang-btn.active {
    background: #f5f5f5;
    color: #000;
  }
}
</style>
